import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Card, CardContent, CardActionArea, Chip, Alert, Button, Paper } from '@mui/material';
import { AccountBalance, Add } from '@mui/icons-material';
import api from '../../services/api';

const statusColors = {
  aktiv: 'success',
  pausiert: 'warning',
  abgeschlossen: 'info',
  abgebrochen: 'error',
};

const FinanzenProjektAuswahl = () => {
  const navigate = useNavigate();
  const [projekte, setProjekte] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get('/projekte');
        setProjekte(res.data);
      } catch (err) { setError('Fehler beim Laden der Projekte'); }
    };
    load();
  }, []);

  const formatCurrency = (val) => val ? parseFloat(val).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : '-';
  const formatDate = (d) => d ? new Date(d).toLocaleDateString('de-DE') : '-';

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" color="#1B5E20" sx={{ mb: 3 }}>
        Finanzen – Projekt wählen
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {projekte.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <AccountBalance sx={{ fontSize: 64, color: '#C8E6C9', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Noch keine Projekte vorhanden
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Erstelle zuerst ein Projekt unter "Projekte".
          </Typography>
          <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/projekte')}
            sx={{ bgcolor: '#1B5E20', '&:hover': { bgcolor: '#2E7D32' } }}>
            Zu den Projekten
          </Button>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {projekte.map((p) => (
            <Grid item xs={12} sm={6} md={4} key={p.id}>
              <Card variant="outlined" sx={{
                transition: 'all 0.2s ease',
                '&:hover': { borderColor: '#1B5E20', boxShadow: '0 4px 20px rgba(27,94,32,0.15)', transform: 'translateY(-2px)' }
              }}>
                <CardActionArea onClick={() => navigate(`/finanzen/${p.id}`)}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                      <AccountBalance sx={{ color: '#1B5E20' }} />
                      <Typography variant="h6" fontWeight="bold" noWrap sx={{ flexGrow: 1 }}>{p.titel}</Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      {p.foerdergeber?.name || 'Kein Fördergeber'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                      Laufzeit: {formatDate(p.laufzeitVon)} – {formatDate(p.laufzeitBis)}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" fontWeight="bold" color="#1B5E20">
                        {formatCurrency(p.bewilligteSumme)}
                      </Typography>
                      <Chip label={p.status} size="small" color={statusColors[p.status] || 'default'} />
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default FinanzenProjektAuswahl;
